export enum DebtCollectionControlStatusType {
  Proposed = 'proposed',
  Approved = 'approved',
  AwaitingCaseNumber = 'awaitingCaseNumber',
  Active = 'active',
  Monitored = 'monitored',
  ClosedLoss = 'closedLoss',
  Closed = 'closed',
  Exempt = 'exempt',
  Unknown = 'unknown',
}

export class DebtCollectionSnapshot {
  controlStatus: DebtCollectionControlStatusType;
  externalReference?: string;
  syncedAt: Date;

  constructor(json: any) {
    this.controlStatus = json.controlStatus as DebtCollectionControlStatusType;
    this.externalReference = json.externalReference ?? undefined;
    this.syncedAt = new Date(json.syncedAt);
  }
}
